import Link from "next/link";

import { useProjectData } from "../ProjectDataContext";
import ProjectType from "./ProjectType";

import { UserFormatableTextOnlyDisplay } from "../form-fields/UserFormatableText";
import { slugifyProject } from "../../utils/common";
import CreatedBy from "../CreatedBy";
import ProjectLocation from "./ProjectLocation";

import { projectListItem } from "./ProjectListItem.module.css";

const statusMap = {
  new: "New Project",
  ongoing: "Ongoing Project",
  completed: "Completed Project",
};

const SimpleProjectListItem = ({ className, project, trimTill }) => (
  <div className={`${projectListItem} box mb-6`}>
    <div className={className}>
      <div className="tags are-medium">
        {project.types.map((type) => (
          <ProjectType key={type} type={type} />
        ))}
        <ProjectLocation project={project} />
      </div>

      <h2 className="subtitle">
        <Link href={`/community-projects/${slugifyProject(project)}`}>
          {project.title}
        </Link>
      </h2>

      <CreatedBy
        className="block"
        user={project.created_by_user}
        createdAt={project.created_at}
      />

      <UserFormatableTextOnlyDisplay
        className="block"
        value={project.description || ""}
        trimTill={trimTill}
      />

      <Link href={`/community-projects/${slugifyProject(project)}`}>
        {"> Read More"}
      </Link>
    </div>
  </div>
);

const ProjectListItem = ({
  project,
  trimTill = 100,
  validSeekingOptionMap,
}) => (
  <div className={`${projectListItem} box mb-6`}>
    <div
      className="columns"
      style={{ overflow: "hidden", textOverflow: "ellipsis" }}
    >
      <div className="column is-one-third">
        <p>
          <strong>{project.name}</strong>
        </p>

        <div className="tags are-medium is-hidden-tablet mt-2">
          <ProjectLocation project={project} />
        </div>

        <p>
          <small>Status: </small>
          {statusMap[project.status]}
        </p>
        <p>
          <small>Seeking: </small>
          <span className="tags">
            {project.seeking.map((projectNeed) => (
              <span className="tag is-light" key={projectNeed}>
                {validSeekingOptionMap[projectNeed] || projectNeed}
              </span>
            ))}
          </span>
        </p>
      </div>

      <div className="column is-two-thirds">
        <div className="tags are-medium">
          {project.types.map((type) => (
            <ProjectType key={type} type={type} />
          ))}
          <ProjectLocation className="is-hidden-mobile" project={project} />
        </div>

        <h2 className="subtitle">
          <Link href={`/community-projects/${slugifyProject(project)}`}>
            {project.title}
          </Link>
        </h2>

        <CreatedBy
          className="block"
          user={project.created_by_user}
          createdAt={project.created_at}
        />

        <UserFormatableTextOnlyDisplay
          className="block"
          value={project.description || ""}
          trimTill={trimTill}
        />

        <Link href={`/community-projects/${slugifyProject(project)}`}>
          {"> Read More"}
        </Link>
      </div>
    </div>
  </div>
);

const ProjectListItemContainer = (props) => {
  const { projectNeedsMap } = useProjectData();

  return <ProjectListItem validSeekingOptionMap={projectNeedsMap} {...props} />;
};

export default ProjectListItemContainer;

export { SimpleProjectListItem };
